module.exports = __webpack_public_path__ + "static/media/package.300b9790.svg";